module.exports = __webpack_public_path__ + "static/img/produto_p.5900547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_laranja/produto_p.png
// module id = LVZX
// module chunks = 0